import type { INavigationRoute } from '@/components/sidebar/NavigationRoutes'

/** Toggle to show outbound messaging in sidebar and on driver profiles (routes remain registered). */
export const OUTBOUND_MESSAGING_UI_VISIBLE = false

const DISABLED_ROUTE_NAMES = new Set(['scorecard'])

const MAINTENANCE_MENU_DISPLAY_NAMES = new Set(['Maintenance', 'Maintenance List', 'Maintenance Items'])

function isMaintenanceMenuRoute(route: INavigationRoute): boolean {
  if (MAINTENANCE_MENU_DISPLAY_NAMES.has(route.displayName)) return true
  if (route.name === 'maintenance-workshops' && route.displayName === 'Workshops') return true
  return false
}

export function isNavRouteHidden(route: INavigationRoute): boolean {
  if (!OUTBOUND_MESSAGING_UI_VISIBLE && route.name === 'outbound-messages') return true
  if (route.displayName === 'Tickets') return true
  if (route.name === 'tickets' && !route.children?.length) return true
  if (route.name === 'finance' && route.displayName === 'Finance') return true
  return false
}

export function isNavRouteDisabled(route: INavigationRoute): boolean {
  return (
    DISABLED_ROUTE_NAMES.has(route.name) || route.meta?.navDisabled === true || isMaintenanceMenuRoute(route)
  )
}

export function applyNavigationPolicy(routes: INavigationRoute[], forceDisabled = false): INavigationRoute[] {
  return routes
    .filter((route) => !isNavRouteHidden(route))
    .map((route) => {
      const navDisabled = forceDisabled || isNavRouteDisabled(route)
      const disableDescendants = forceDisabled || route.displayName === 'Maintenance'
      const children = route.children ? applyNavigationPolicy(route.children, disableDescendants) : undefined
      return {
        ...route,
        meta: navDisabled ? { ...route.meta, navDisabled: true } : route.meta,
        ...(children ? { children } : {}),
      }
    })
    .filter((route) => !route.children || route.children.length > 0)
}
